import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function audit(payload) {
  return request(`/iwms-wms/wms/pick/audit`, {
    method: 'POST',
    body: payload,
  })
}

export async function normalAudit(payload) {
  return request(`/iwms-wms/wms/pick/${payload.uuid}/normalAudit?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/pick/modify`, {
    method: 'POST',
    body: payload,
  })
}

export async function modifyOperate(payload) {
  return request(`/iwms-wms/wms/pick/${payload.uuid}/modifyOperateMethod?version=${payload.version}`, {
    method: 'POST',
  })
}

export async function batchAudit(payload) {
  return request(`/iwms-wms/wms/pick/${payload.uuid}/auditInitial?version=${payload.version}&pickQty=${payload.pickQty}`, {
    method: 'POST',
    body: payload.picker,
  })
}

export async function query(payload) {
  return request(`/iwms-wms/wms/pick/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/pick/${payload.uuid}`);
}

export async function modifyPicker(payload) {
  return request(`/iwms-wms/wms/pick/${payload.billNumber}/modifyPicker?dcUuid=${payload.dcUuid}&pickerCode=${payload.pickerCode}`, {
    method: 'POST',
  })
}

export async function printLabel(payload) {
  return request(`/iwms-wms/wms/pick/printLabel`, {
    method: 'POST',
    body: payload,
  })
}

export async function queryElectronicRecord(payload) {
  return request(`/iwms-wms/wms/pick/queryRfidPickupBills`, {
    method: 'POST',
    body: payload,
  })
}

export async function printElectronicLabel(payload) {
  return request(`/iwms-wms/wms/pick/batchPrintLabel`, {
    method: 'POST',
    body: payload,
  })
}

export async function recalculate(payload) {
  return request(`/iwms-wms/wms/pick/recalculateContainers?dcUuid=${payload.dcUuid}`, {
    method: 'POST',
    body: payload.billNumbers,
  })
}

export async function getServerDate() {
  return request(`/iwms-wms/wms/date`)
}

export async function getByNumber(billNumber) {
  return request(`/iwms-wms/wms/pick/${billNumber}/get?dcUuid=${loginOrg().uuid}`);
}

export async function queryAllocateBinDashboard(payload) {
  return request(`/iwms-wms/wms/sowingpick/queryAllocateBinDashboard`, {
    method: 'POST',
    body: payload,
  });
}

export async function adjustAllocateBin(payload) {
  return request(`/iwms-wms/wms/sowingpick/adjustAllocateBin`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryUnifyStoreCollectBinInfo(payload) {
  return request(`/iwms-wms/wms/pick/queryUnifyStoreCollectBinInfo`, {
    method: 'POST',
    body: payload,
  });
}

export async function modifyCollectBin(payload) {
  return request(`/iwms-wms/wms/pick/modifyCollectBin`, {
    method: 'POST',
    body: payload,
  });
}

export async function modifyPickType(payload) {
  return request(`/iwms-wms/wms/pick/${payload.uuid}/modifyPickType?version=${payload.version}`, {
    method: 'POST'
  })
}

export async function effect(payload) {
  return request(`/iwms-wms/wms/storeCollectBin/effect?itemUuid=${payload.itemUuid}`, {
    method: 'POST'
  })
}

export async function finish(payload) {
  return request(`/iwms-wms/wms/storeCollectBin/finish?itemUuid=${payload.itemUuid}`, {
    method: 'POST'
  })
}
//---abort
export async function page(payload) {
  return request(`/iwms-wms/wms/pickInfoAdjust/page`, {
    body: payload,
    method: 'POST'
  })
}

export async function getItem(payload) {
  return request(`/iwms-wms/wms/pickInfoAdjust/${payload.uuid}`, {
    method: 'GET'
  })
}

export async function save(payload) {
  return request(`/iwms-wms/wms/pickInfoAdjust/save`, {
    body: payload,
    method: 'POST'
  })
}

export async function verifyBin(payload) {
  return request(`/iwms-wms/wms/storeCollectBin/verifyBin?itemUuid=${payload.itemUuid}`, {
    method: 'POST',
    body: payload.districtCollectBin,
  })
}

export async function updateItem(payload) {
  return request(`/iwms-wms/wms/storeCollectBin/updateItem?itemUuid=${payload.itemUuid}`, {
    method: 'POST',
    body: payload.districtCollectBin,
  })
}
//根据头部uuids查询明细集合
export async function queryItemsByPIAId(payload) {
  return request(`/iwms-wms/wms/pickInfoAdjust/queryItemsByPIAId`, {
    method: 'POST',
    body: payload.filter
  })
}

export async function getByidAndFilter(payload) {
  return request(`/iwms-wms/wms/pickInfoAdjust/getByidAndFilter?uuid=${payload.uuid}`, {
    method: 'POST',
    body: payload.filter
  })
}
//根据门店id集合和筛选条件查询明细集
export async function queryItemsByStore(payload) {
  return request(`/iwms-wms/wms/storeCollectBin/queryItemsByStore`, {
    method: 'POST',
    body: payload.filter
  })
}

export async function storeCollectBinpage(payload) {
  return request(`/iwms-wms/wms/storeCollectBin/page`, {
    method: 'POST',
    body: payload
  })
}

export async function print(payload) {
  return request(`/iwms-wms/wms/pick/rfid/print`, {
    method: 'POST',
    body: payload.uuids
  })
}

//拣货数量调整
export async function pickqtyadjQuery(payload) {
  return request(`/iwms-wms/wms/pickqtyadj/query`, {
    method: 'POST',
    body: payload
  })
}

export async function pickqtyadj(payload) {
  return request(`/iwms-wms/wms/pickqtyadj/adj`, {
    method: 'POST',
    body: payload
  })
}

//拣货分组
export async function groupWithNum(payload) {
  return request(`/iwms-wms/wms/pickGroupTask/group?groupNum=${payload.groupNum}`, {
    method: 'POST',
    body: payload.list
  })
}

export async function pagePickGroupTask(payload) {
  return request(`/iwms-wms/wms/pickGroupTask/page`, {
    method: 'POST',
    body: payload
  })
}

export async function releasePickGroupTask(payload) {
  return request(`/iwms-wms/wms/pickGroupTask/release?pickGroupTaskUuid=${payload.pickGroupTaskUuid}`, {
    method: 'POST',
    body: payload
  })
}

export async function printPickGroupTask(payload) {
  return request(`/iwms-wms/wms/pickGroupTask/print`, {
    method: 'POST',
    body: payload
  })
}

//打印标签拣货
export async function realPrintLabelaudit(payload) {
  return request(`/iwms-wms/wms/pick/realPrintLabel?audit=${payload.audit}&dcUuid=${payload.dcUuid}&printer=${payload.printer}`, {
    method: 'POST',
    body: payload.billNumbers,
  });
}
